// @ts-nocheck
import React from 'react';
import { ProvideAlias } from "./State/ProvideAlias";
import { ProvideAreas } from "../Areas/State/ProvideAreas";
import AliasConsulta from "./AliasConsulta";


const Alias = () => {

    return (
        <ProvideAreas>
            <ProvideAlias>
                <AliasConsulta></AliasConsulta>
            </ProvideAlias>
        </ProvideAreas>
    );
};

export default Alias;
